import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');
import TileListEmpty from '../tiles/TileListEmpty';
import ProjectTileNew from '../tiles/ProjectTileNew';
import WelcomePrompt from './WelcomePrompt';

const propTypes = {
    createProjectFunc: PropTypes.func.isRequired,
    prompt: PropTypes.string,
};

const defaultProps = {
    prompt: '',
};

function TileListNewProject({ createProjectFunc, prompt }) {

    return (
        <TileListEmpty tileListClass="tileList--justifyCenter" promptText={prompt}>
            <ProjectTileNew onClick={createProjectFunc} />
            <WelcomePrompt
                className="margin-top-lg"
            />
        </TileListEmpty>
    );
}

TileListNewProject.propTypes = propTypes;
TileListNewProject.defaultProps = defaultProps;

export default TileListNewProject;
